/* Collection copy — collapse it, and offer the rest.
   ------------------------------------------------------------------
   Clamped by script rather than in the markup so that a page whose copy is
   already short never grows a Read more button for two sentences. The text
   itself is always in the HTML; only its height is touched. */

(function () {
  'use strict';

  function setUp() {
    var body = document.querySelector('[data-tc-coll-body]');
    if (!body || body.__tcReady) return;

    /* Nothing to collapse. Measured against the clamp height rather than a
       character count, because two paragraphs of long words and ten of short
       ones occupy the same page and read very differently. */
    var clampHeight = parseFloat(getComputedStyle(body).fontSize) * 11;
    if (body.scrollHeight <= clampHeight * 1.15) return;

    body.__tcReady = true;
    body.classList.add('is-clamped');

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'tc-coll-desc__toggle';
    toggle.textContent = 'Read more';
    toggle.setAttribute('aria-expanded', 'false');

    toggle.addEventListener('click', function () {
      var open = body.classList.toggle('is-clamped') === false;
      toggle.textContent = open ? 'Read less' : 'Read more';
      toggle.setAttribute('aria-expanded', String(open));
      // Collapsing from the bottom of a long block would otherwise leave the
      // reader somewhere further down the page than the text they were on.
      if (!open) toggle.scrollIntoView({ block: 'nearest' });
    });

    body.insertAdjacentElement('afterend', toggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setUp);
  } else {
    setUp();
  }
})();
